var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-item',_vm._g(_vm._b({staticClass:"toggle-collapse-button",class:{'is-active': _vm.isActive},attrs:{"title":_vm.title,"right-icon":'arrow-down-sm',"disabled":_vm.disabled}},'list-item',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }